enum VodTypeEnum {
  MeetAppLive = 0,
  Mux = 1,
  RTMP = 2,
  MeetAppLiveRecording = 3,
}
export default Object.freeze(VodTypeEnum);
